import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import {
  DialogTitleClose,
  PaperComponent,
} from "./components/dialog";
import "./Consent.css";

// 상단에 스타일 컴포넌트 추가
const FlowingTitle = () => (
  <Box
    component="div"
    sx={{
      fontSize: '2.2rem',
      fontWeight: 'bold',
      padding: '10px 20px',
      color: '#ffffff',
      background: 'linear-gradient(90deg, #ff0000, #FFCCCB, #ee0000, #ff0000)',
      backgroundSize: '200% 100%',
      animation: 'flowing 3s ease-out 1s infinite',  // 애니메이션 속도와 지연 시간 조정
      borderRadius: '4px',
      textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      '@keyframes flowing': {
        '0%': {
          backgroundPosition: '100% 0%',  // 시작 위치를 왼쪽으로
        },
        '100%': {
          backgroundPosition: '-100% 0%',  // 끝 위치를 오른쪽으로
        },
      }
    }}
  >
    KFGWA 공사다큐 이용 업체를 위한 HOT!! 이벤트
  </Box>
);

const PromotionDialog = ({
  open,
  setOpen,
  fromEvent,
}) => {
  const [hideForToday, setHideForToday] = useState(false);

  const sessionUser = useSelector(state => state.session.sessionUser);

  const handleDialogClose = (e, reason) => {
    if (setOpen) {
      setOpen(false);
    }
  };

  const handleDownload = (type) => {
    if (sessionUser) {
      const fileName = `주문서.${type}`;
      window.open(`/${fileName}`);
    } else {
      window.location.href = '/glass/signin/gclient?promotion=true';
    }
  };

  const handleHideForToday = (e) => {
    setHideForToday(e.target.checked);
    if (e.target.checked) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      localStorage.setItem('promotionHideUntil', tomorrow.toISOString());
      setOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      // maxWidth="lg"
      onClose={handleDialogClose}
      disableEscapeKeyDown
      sx={{ 
        zIndex: 9999,
        '& .MuiDialog-paper': {
          // minHeight: '98vh',  // 뷰포트 높이의 90%
          minWidth: '800px',
        }
      }}
      scroll="body"
    >
      <DialogTitleClose
        id="draggable-dialog-title"
        // onClose={handleDialogClose}
        style={{ cursor: 'move' }}
      >
        <FlowingTitle />
      </DialogTitleClose>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} display="flex" justifyContent="flex-start" alignItems="flex-end" sx={{ ml: 1, mb: 1}}>
                <span>복층유리용 휴대용 가스측정기</span><span style={{ marginLeft: '10px', fontWeight: 'bold', fontSize: '2rem' }}>"Sparklike" 기간 한정 할인 판매!!!</span>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
                <img src="/promotion_sparklike_202504.png" alt="Sparklike" style={{ width: '90%' }} />
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mt: 1, p: 2 }}>
                <Typography variant="body1" sx={{ mb: 3, letterSpacing: '0.04rem', lineHeight: '2' }}>&nbsp;핀란드 Sparklike의 총판 대리점인 티앤티㈜에서 KFGWA공사다큐를 이용하는 회원사를 위해 한정 수량만 할인 판매를 실시합니다.  그리고 무엇보다 파격적인 것은 이번에 구입한 측정기의 경우 2년 무상 교정 서비스까지 추가로 혜택을 마련하였으니 많은 관심 가져주시기 바랍니다.</Typography>
              </Grid>
            </Grid>
            <Box>
              <Box sx={{ 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                overflow: 'hidden',
                mt: 1,
              }}>
                <Grid container>
                  <Grid item xs={3} sx={{ 
                    bgcolor: '#f5f5f5', 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd',
                    fontWeight: 'bold'
                  }}>
                    1. 행사기간
                  </Grid>
                  <Grid item xs={9} sx={{ 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd'
                  }}>
                    2025년 4월 14일 ~ 6월 30일
                  </Grid>
                  
                  <Grid item xs={3} sx={{ 
                    bgcolor: '#f5f5f5', 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd',
                    fontWeight: 'bold'
                  }}>
                    2. 행사품목
                  </Grid>
                  <Grid item xs={9} sx={{ 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd'
                  }}>
                    Sparklike Handheld™ 3.0 (핸드헬드 버전) – 한정수량
                  </Grid>
                  
                  <Grid item xs={3} sx={{ 
                    bgcolor: '#f5f5f5', 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd',
                    fontWeight: 'bold'
                  }}>
                    3. 행사가격
                  </Grid>
                  <Grid item xs={9} sx={{ 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd'
                  }}>
                    <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>16,000,000원</span> (정상 가격 : 17,500,000원) <span style={{ fontWeight: 'bold' }}>VAT별도</span>
                    <br />
                    <span style={{ fontWeight: 'bold' }}> +추가혜택 : </span>
                    <span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#ff0000' }}>2년 무상 공식 교정 서비스</span>
                  </Grid>
                  <Grid item xs={3} sx={{ 
                    bgcolor: '#f5f5f5', 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd',
                    fontWeight: 'bold'
                  }}>
                    4. 신청방법
                  </Grid>
                  <Grid item xs={9} sx={{ 
                    p: 1.5, 
                    borderBottom: '1px solid #ddd'
                  }}>
                    <span>주문서 작성 후 아래의 메일로 회신 또는 팩스 발송</span>
                    <br />
                    <span>협회 기업지원본부 <a href="mailto:yjkim@flatglass.or.kr">yjkim@flatglass.or.kr</a>, FAX : 02-3453-0550</span>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ fontSize: '0.9rem' }}>
            {/* 다운로드 버튼 */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="contained"
                  startIcon={<PictureAsPdfIcon />}
                  onClick={() => handleDownload('pdf')}
                  sx={{ mt: 1, mb: 2, fontSize: '1.2rem' }}
                  fullWidth
                >
                  주문서 다운로드(pdf)
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button 
                  variant="contained"
                  startIcon={<ArticleIcon />}
                  onClick={() => handleDownload('docx')}
                  sx={{ mt: 1, mb: 2, fontSize: '1.2rem' }}
                  fullWidth
                >
                  주문서 다운로드(docx)
                </Button>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mt: 1 }}>
              <Grid item xs={12} display="flex" justifyContent="center">
                <img src="/promotion_sponsor_202504.png" alt="Sparklike" style={{ width: '60%' }} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} display="flex" justifyContent="flex-start">
            <FormControlLabel
              control={
                <Checkbox
                  checked={hideForToday}
                  onChange={handleHideForToday}
                />
              }
              sx={{ ml: 2, display: fromEvent ? 'none' : 'block' }}
              label="오늘 하루 동안 보지 않기"
            />
          </Grid>
          <Grid item xs={12} sm={6} display="flex" justifyContent="flex-end">
            <Button variant="text" onClick={handleDialogClose}>닫기</Button>  
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default PromotionDialog;
